import { api } from "../api";

/** Public platform status (no exemption list). */
export interface PlatformStatus {
  maintenance_mode: boolean;
  message: string | null;
  /**
   * SCRUM-768: ISO instant the student app opens to students, or null for no
   * countdown. Sent as an absolute instant, never a wall clock — the launch
   * time is stated in Mexico City time and clients live in other zones.
   */
  student_launch_at: string | null;
}

/** Admin-only platform status, including the maintenance exemption list. */
export interface FullPlatformStatus extends PlatformStatus {
  allowed_school_ids: number[];
  allow_coordinators: boolean;
}

export interface UpdatePlatformStatusDto {
  maintenance_mode: boolean;
  message?: string | null;
  allowed_school_ids?: number[];
  // Optional: undefined preserves the currently saved value on the backend
  allow_coordinators?: boolean;
  // Optional: undefined preserves the saved date, explicit null removes the
  // countdown and opens the student app immediately.
  student_launch_at?: string | null;
}

/**
 * Get the public platform status. Does NOT include `allowed_school_ids`;
 * admin screens must use `getFullPlatformStatus` instead.
 */
export const getPlatformStatus = async (): Promise<PlatformStatus> => {
  const response = await api.get("/platform-status");
  return response.data;
};

/**
 * Get the full platform status for the admin panel, including
 * `allowed_school_ids` (the schools that keep access during maintenance).
 * ADMIN-only endpoint.
 */
export const getFullPlatformStatus = async (): Promise<FullPlatformStatus> => {
  const response = await api.get("/platform-status/full");
  return response.data;
};

/**
 * Update the platform status. Requires an admin token
 * (already attached by the shared api instance).
 */
export const updatePlatformStatus = async (
  data: UpdatePlatformStatusDto
): Promise<FullPlatformStatus> => {
  const response = await api.put("/platform-status", data);
  return response.data;
};
